import axios from 'axios'

export default {
  state: {
    user: null,
    manager: null,
    publisher: null,
  },

  getters: {
    signedIn: state => state.user !== null
  },

  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },

    SET_MANAGER(state, manager) {
      state.manager = manager;
    }
  },

  actions: {
    async loadUser({commit}) {
      let response = await axios.get("/admin/api/manager");
      commit("SET_MANAGER", response.data.data);
      commit("SET_USER", response.data.data.user);
    }
  }
};
